import { useCallback } from 'react';
import { useLocation } from '@provider/navigation';
import { useComponentDisplayContext } from '@utils/component-framework';

function taskToHref(displayContext, location, taskId) {
  if (displayContext !== "standalone" || !taskId) {
    return taskId ? `/${taskId}` : "";
  }
  try {
    const url = new URL(location.asPath, "http://localhost");
    url.searchParams.set("taskId", taskId);
    return `${url.pathname}${url.search}`;
  } catch {
    return `?taskId=${taskId}`;
  }
}
function useTaskToHref() {
  const displayContext = useComponentDisplayContext();
  const location = useLocation();
  return useCallback(taskId => taskToHref(displayContext, location, taskId), [displayContext, location]);
}

export { taskToHref, useTaskToHref };
//# sourceMappingURL=util.task-to-href.js.map
